import type { Messages } from './en';

/**
 * Turkish translations.
 *
 * Keys MUST match `Messages` exactly (TypeScript enforces this).
 * Interpolation tokens are `{{name}}`.
 */
export const tr: Messages = {
  app: {
    name: '0xCent Escrow',
    tagline: "Telegram icinde guvenli TON escrow'u",
    loading: 'Yukleniyor...',
  },
  common: {
    back: 'Geri',
    next: 'Ileri',
    cancel: 'Iptal',
    confirm: 'Onayla',
    retry: 'Tekrar dene',
    close: 'Kapat',
    error: 'Bir seyler ters gitti',
    emptyTitle: 'Henuz burada bir sey yok',
    emptyDescription: 'Daha sonra tekrar bak ya da yeni bir deal olustur.',
    tryAgain: 'Tekrar dene',
    loading: 'Yukleniyor',
    copy: 'Kopyala',
    copied: 'Kopyalandi',
  },
  placeholder: {
    title: '{{page}} yakinda',
    description:
      'Bu ekran Wave A stubs. Gercek icerik Wave B veya C ile gelecek.',
  },
  error: {
    boundaryTitle: 'Beklenmeyen hata',
    boundaryDescription:
      'Uygulama toparlayamadigi bir hataya takildi. Mini App\'i Telegram uzerinden yeniden acmayi dene.',
    reload: 'Yeniden yukle',
  },
  nav: {
    home: 'Ana sayfa',
    deals: 'Dealler',
    profile: 'Profil',
  },
  onboarding: {
    hero: {
      title: '0xCent',
      tagline: "TON uzerinde guvenli emanet, dogrudan Telegram'in icinde.",
    },
    feature: {
      nonCustodial: {
        title: 'Non-custodial',
        body: 'Paralar akilli kontratta durur, asla bizim elimizde olmaz.',
      },
      instant: {
        title: 'Aninda',
        body: 'Bir dakikadan kisa surede deploy et, fonla, serbest birak.',
      },
      fair: {
        title: 'Adil',
        body: 'Zincirde kanitli, dahili anlasmazlik cozumu.',
      },
    },
    connectWallet: "Tonkeeper'i bagla",
    tonkeeperHint: "Tonkeeper otomatik acilir. Testnet'in acik oldugundan emin ol.",
    skipForNow: 'Simdilik gec',
    welcomeBack: 'Tekrar hosgeldin, {{name}}',
    unauthorized: {
      title: "Bu uygulamayi Telegram'in icinden ac",
      body: 'Bu Mini App, kim oldugunu dogrulayabilmemiz icin bir Telegram sohbeti uzerinden acilmali.',
    },
  },
  dealList: {
    title: 'Anlasmalarim',
    newDeal: 'Yeni Anlasma',
    refresh: 'Yenile',
    filter: {
      role: {
        all: 'Tumu',
        buyer: 'Alici olarak',
        seller: 'Satici olarak',
      },
      status: {
        all: 'Tumu',
        active: 'Aktif',
        completed: 'Tamamlandi',
        disputed: 'Anlasmazlik',
        cancelled: 'Iptal',
      },
    },
    empty: {
      title: 'Henuz anlasman yok',
      body: 'Ilk emanet anlasmani olustur ve TON uzerinde guvenle ticarete basla.',
      cta: 'Ilk anlasmani olustur',
    },
    filtered: {
      empty: 'Bu filtreye uyan anlasma yok',
      clear: 'Filtreleri temizle',
    },
    error: {
      title: 'Anlasmalarin yuklenemedi',
    },
    status: {
      created: 'Olusturuldu',
      funded: 'Para yatirildi',
      active: 'Devam ediyor',
      delivered: 'Teslim edildi',
      completed: 'Tamamlandi',
      disputed: 'Anlasmazlik',
      resolved: 'Cozuldu',
      cancelled: 'Iptal edildi',
      expired: 'Suresi doldu',
      refunded: 'Iade edildi',
    },
    role: {
      buyer: 'Alici',
      seller: 'Satici',
    },
  },
  newDeal: {
    title: 'Yeni Anlasma',
    stepIndicator: 'Adim {{current}} / {{total}}',
    step: {
      amount: {
        title: 'Ne kadar?',
        helper: 'Emanete kilitlenecek TON miktarini gir.',
        placeholder: '0.0',
        usdEquivalent: '~${{amount}}',
        quickPick: 'Hizli sec',
        currencyLabel: 'Para birimi',
        currencyTon: 'TON',
        currencyUsdt: 'USDT',
        currencyUsdtSoon: 'Phase 4 ile gelecek',
      },
      seller: {
        title: 'Satici kim?',
        helper:
          "Saticinin @kullaniciadi veya Telegram ID'sini gir. Saticinin botu en az bir kez acmis olmasi gerekir.",
        placeholder: '@kullaniciadi veya 123456789',
        usernameUnsupported:
          "Kullanici adi aramasi yakinda gelecek; simdilik Telegram ID'si kullan.",
        searching: 'Kullanici adi araniyor…',
        resolved: '@{username} ({name}) bulundu',
        notFound:
          'Bu kullanici adiyla botu acmis biri bulunamadi. Once botu baslatmasini iste.',
      },
      details: {
        title: 'Detaylar',
        helper: 'Alicinin ne icin odeme yaptigini kisaca anlat.',
        titleLabel: 'Baslik',
        titlePlaceholder: 'orn. SaaS landing icin logo tasarimi',
        categoryLabel: 'Kategori',
        descriptionLabel: 'Aciklama',
        descriptionPlaceholder:
          'Kapsam, teslim, son tarihler — saticinin bilmesi gereken her sey.',
        descriptionCount: '{{count}} / {{max}}',
        addTerms: 'Ozel sartlar ekle',
        hideTerms: 'Ozel sartlari gizle',
        termsLabel: 'Ozel sartlar (opsiyonel)',
        termsPlaceholder:
          'Iki tarafi da bu anlasma icin baglayacak opsiyonel sartlar.',
        timeoutLabel: 'Fonlama suresi',
        timeoutDays: '{{days}} gun',
        timeoutHours: '{{hours}} saat',
        timeoutCombined: '{{days}}g {{hours}}s',
      },
      confirm: {
        title: 'Goster ve olustur',
        helper: 'Yayinlamadan once her seyi kontrol et.',
        summaryAmount: 'Tutar',
        summarySeller: 'Satici',
        summaryTitle: 'Baslik',
        summaryCategory: 'Kategori',
        summaryDescription: 'Aciklama',
        summaryTerms: 'Ozel sartlar',
        summaryTimeout: 'Fonlama suresi',
        disclaimer:
          "Davet kabul edildigi an anlasma blockchain'e yazilir. Zaman asimi suresi icinde kontrati fonlaman gerekir, aksi halde anlasma suresi dolar.",
        noSellerYet:
          'Saticiyi simdi girmene gerek yok — davetiye olusturduktan sonra link ile paylasacaksin.',
      },
      share: {
        title: 'Davetiye hazir!',
        subtitle:
          'Bu linki saticiyla paylas. Link acildiginda anlasma otomatik olarak zincire yazilir.',
        cardAmount: 'Tutar',
        cardExpires: 'Sona eriyor',
        shareButton: "Telegram'da Paylas",
        copyButton: 'Linki kopyala',
        copied: 'Link kopyalandi',
        done: 'Tamam',
        footer: 'Bitti mi? Sihirbazi kapatabilirsin.',
        inviteMessage:
          "Merhaba — 0xCent uzerinde {{amount}} TON'luk bir emanet icin seni davet ediyorum: {{title}}. Gozden gecirmek ve kabul etmek icin bu linke tikla: {{link}}",
      },
    },
    button: {
      continue: 'Devam',
      create: 'Anlasmayi Olustur',
      creating: 'Olusturuluyor...',
      createInvite: 'Daveti Olustur',
      creatingInvite: 'Davet olusturuluyor...',
      doneShare: 'Tamam',
    },
    category: {
      freelance: 'Freelance',
      otc: 'OTC takas',
      nft: 'NFT',
      service: 'Hizmet',
      goods: 'Fiziksel urun',
      other: 'Diger',
    },
    error: {
      invalidAmount: 'Gecerli bir TON tutari gir (en fazla 9 ondalik).',
      invalidSeller: "Saticinin Telegram ID'si sayisal olmali.",
      titleTooShort: 'Baslik en az 3 karakter olmali.',
      descriptionTooShort: 'Aciklama en az 10 karakter olmali.',
      createFailed: 'Anlasma olusturulamadi. Lutfen tekrar dene.',
    },
  },
  dealDetail: {
    header: {
      title: 'Anlasma',
      youLabel: 'Sen',
      justCreatedBanner: 'Anlasma olusturuldu! Linki saticiyla paylas.',
      copied: 'Panoya kopyalandi',
    },
    roles: {
      buyer: 'Alici',
      seller: 'Satici',
    },
    details: {
      sectionTitle: 'Detaylar',
      description: 'Aciklama',
      terms: 'Ozel sartlar',
      category: 'Kategori',
      createdAt: 'Olusturuldu',
      fundingDeadline: 'Fonlama son tarihi',
      deliveryDeadline: 'Teslim son tarihi',
      contractAddress: 'Escrow kontrat',
      contractNotDeployed: 'Kontrat henuz deploy edilmedi',
      txDeploy: 'Deploy tx',
      txFund: 'Fon tx',
      txRelease: 'Serbest birakma tx',
      txRefund: 'Iade tx',
      viewOnExplorer: 'Explorer uzerinde gor',
      noTerms: 'Ozel sart yok',
      none: '—',
    },
    counterparty: {
      title: 'Taraflar',
      placeholderUser: 'Kullanici #{{id}}',
    },
    timeline: {
      title: 'Zaman cizelgesi',
      created: 'Anlasma olusturuldu',
      funded: 'Fonlar kilitlendi',
      active: 'Calisma devam ediyor',
      delivered: 'Teslim edildi olarak isaretlendi',
      completed: 'Fonlar serbest birakildi',
      disputed: 'Anlasmazlik acildi',
      resolved: 'Anlasmazlik cozuldu',
      cancelled: 'Iptal edildi',
    },
    action: {
      fund: 'Fonla',
      fundWaiting: 'Fonlamak icin cuzdani ac',
      fundConfirming: 'Zincirde onay bekleniyor...',
      markDelivered: 'Teslim Edildi Olarak Isaretle',
      markDeliveredTitle: 'Teslim edildi olarak isaretle?',
      markDeliveredConfirm:
        "Isi tamamladigini ya da urunu gonderdigini onayla. Alici, fonlari serbest birakmasi icin bilgilendirilecek.",
      release: 'Fonlari Serbest Birak',
      releaseTitle: 'Fonlari saticiya birakmak istiyor musun?',
      releaseConfirm:
        'Bu islem emanetteki fonlari saticiya gonderir. Geri alinamaz.',
      cancel: 'Anlasmayi Iptal Et',
      cancelTitle: 'Bu anlasmayi iptal etmek istiyor musun?',
      cancelConfirm:
        'Anlasma fonlanmissa kilitli tutar aliciya iade edilir. Bu islem geri alinamaz.',
      openDispute: 'Anlasmazlik Ac',
      openDisputeTitle: 'Anlasmazlik acmak istiyor musun?',
      openDisputeConfirm:
        'Sadece gercekten bir sorun varsa anlasmazlik ac. Bu islem emanet fonlarini dondurur ve karari bir hakeme birakir. Satici isi dogru sekilde teslim ettiyse "Fonlari Serbest Birak" butonunu kullan.',
      openDisputeContinue: 'Evet, anlasmazlik ac',
      waitingForBuyer: 'Alicinin fonlamasi bekleniyor',
      waitingForSeller: 'Saticinin teslim etmesi bekleniyor',
      readonly: 'Bu anlasma kapatildi',
    },
    disputeBanner: {
      title: 'Anlasmazlik Devam Ediyor',
      body: 'Bu anlasma hakkinda bir anlasmazlik acildi. Savunmanizi yazmak veya mesajlari gormek icin Dispute Merkezine gidin.',
      cta: 'Dispute Merkezine Git',
    },
    error: {
      notFound: 'Anlasma bulunamadi',
      notFoundBody: 'Bu anlasma mevcut degil ya da erisim yetkin yok.',
      backToDeals: 'Anlasmalara don',
      network: 'Anlasma yuklenemedi. Lutfen tekrar dene.',
      stateChanged: 'Anlasma durumu degisti, lutfen sayfayi yenile.',
      connectWallet: 'Bu anlasmayi fonlamak icin TON cuzdanini bagla.',
      transactionFailed: 'Islem basarisiz oldu ya da reddedildi.',
      contractMissing: 'Escrow kontrati henuz hazir degil. Bir kac saniye sonra yenile.',
      nonCustodialViolation:
        'Fon gondermeyi reddediyoruz: donen adres escrow kontrati degil.',
      pollTimeout:
        "Fonlama gonderildi ama henuz zincirde gorunmuyor. Birkac saniye icinde yenile.",
    },
    success: {
      completedTitle: 'Anlasma tamamlandi',
      completedBody: 'Fonlar saticiya gonderildi.',
    },
    countdown: {
      expiresIn: '{{time}} icinde sona erer',
      expired: 'Suresi doldu',
    },
    deadline: {
      funding: {
        label: 'Fonlama suresi',
        hint: 'Alici bu sure bitmeden kontrati fonlamali.',
      },
      delivery: {
        label: 'Teslim suresi',
        hint: 'Satici bu sure bitmeden teslim etmeli.',
      },
      review: {
        label: 'Inceleme suresi',
        hint: 'Alici onaylamazsa fonlar bu sure sonunda otomatik saliverilir.',
      },
      expired: 'Sure doldu',
    },
    extension: {
      buyerButton: 'Sureyi uzat',
      sellerButton: 'Ek sure iste',
      modalTitle: 'Sureyi uzat',
      modalTitleBuyer: 'Saticiya ek sure ver',
      modalTitleSeller: 'Aliciden ek sure iste',
      hoursLabel: 'Eklenecek saat',
      hoursPlaceholder: 'orn. 24',
      reasonLabel: 'Sebep (opsiyonel)',
      reasonPlaceholder: 'Neden ek sureye ihtiyacin var?',
      submit: 'Gonder',
      submitting: 'Gonderiliyor...',
      errorInvalidHours: 'Lutfen 1 ile 168 arasinda tam sayi gir.',
      errorSubmit: 'Istek gonderilemedi. Lutfen tekrar dene.',
      buyerSuccess: 'Sure uzatildi.',
      sellerSuccess: 'Istegin aliciya iletildi.',
      pendingCardTitle: 'Sure uzatma istegi bekliyor',
      pendingCardBodyBuyer: 'Satici ek sure istiyor. Incele ve karar ver.',
      pendingCardBodySeller: 'Istegin icin alicinin onayi bekleniyor.',
      pendingRequestBy: 'Isteyen',
      pendingRequestHours: '+{{hours}} saat',
      pendingRequestReason: 'Sebep',
      approve: 'Onayla',
      reject: 'Reddet',
      approving: 'Onaylaniyor...',
      rejecting: 'Reddediliyor...',
      approveSuccess: 'Uzatma onaylandi.',
      rejectSuccess: 'Istek reddedildi.',
    },
    note: {
      optional: 'Not (opsiyonel)',
      placeholder: 'Aliciya iletmek istedigin bir seyler...',
    },
    reason: {
      optional: 'Sebep (opsiyonel)',
      placeholder: 'Bu anlasmayi neden iptal ediyorsun?',
    },
  },
  profile: {
    title: 'Profil',
    identity: {
      anonymous: 'Anonim Kullanici',
      telegramId: 'Telegram ID',
      role: {
        user: 'Kullanici',
        arbiter: 'Hakem',
        admin: 'Yonetici',
      },
      banned: {
        title: 'Hesap askiya alindi',
        body: '0xCent erisimin askiya alindi. Sebep: {{reason}}',
      },
    },
    reputation: {
      title: 'Itibar',
      scoreLabel: '{{score}} / 100',
      totalDeals: 'Toplam anlasma',
      completed: 'Tamamlanan',
      disputed: 'Anlasmazlikli',
      totalVolume: 'Toplam hacim',
      footer:
        'Itibar puani tamamlanan ve anlasmazlikli islemlerden hesaplanir.',
    },
    wallet: {
      title: 'TON Cuzdani',
      empty: 'Cuzdan bagli degil',
      connect: "Tonkeeper'i bagla",
      reconnect: 'Cuzdani degistir',
      disconnect: 'Baglantiyi kes',
      disconnectHint:
        "Hem Tonkeeper'dan hem profilinden cuzdani kaldirir.",
      disconnectSuccess: 'Cuzdan baglantisi kesildi',
      viewOnExplorer: "Tonviewer'da gor",
      mismatch: {
        title: 'Cuzdan eslesmiyor',
        body: 'Bagli cuzdanin profilindeki cuzdanla ayni degil.',
        cta: 'Profili guncelle',
      },
      updateSuccess: 'Cuzdan guncellendi',
      updateFailed: 'Cuzdan guncellenemedi. Lutfen tekrar dene.',
    },
    settings: {
      title: 'Ayarlar',
      language: 'Dil',
      theme: 'Tema',
      themeControlled: 'Telegram tarafindan kontrol edilir',
      about: 'Hakkinda',
      version: 'Surum {{version}}',
      website: 'Web sitesi',
      privacy: 'Gizlilik politikasi',
      terms: 'Kullanim sartlari',
    },
    error: {
      loadFailed: 'Profilin yuklenemedi.',
      retry: 'Tekrar dene',
    },
  },
  dispute: {
    title: 'Anlasmazlik',
    backToDeal: 'Anlasmaya don',
    error: {
      notDisputable:
        'Bu anlasma anlasmazlik acmaya uygun bir durumda degil. Yalnizca aktif veya teslim edilmis anlasmalarda anlasmazlik acilabilir.',
      notFound: 'Anlasmazlik bulunamadi',
      loading: 'Anlasmazlik yuklenemedi. Lutfen tekrar dene.',
    },
    phase: {
      open: {
        title: 'Anlasmazlik ac',
        stepIndicator: 'Adim {{current}} / {{total}}',
        step: {
          reason: {
            title: 'Neden anlasmazlik aciyorsun?',
            helper:
              'En yakin nedeni sec. Detaylari sonraki adimda ekleyebilirsin.',
          },
          details: {
            title: 'Ne oldu, anlat',
            helper:
              'Sorunu kendi sozlerinle anlat. Net ol — hakem senin tarafini bunu okuyarak anlayacak.',
            placeholder:
              'Neyin ters gittigini, ne zaman olduğunu ve neler denediğini anlat...',
            charCount: '{{count}} / {{max}}',
          },
          confirm: {
            title: 'Anlasmazligi onayla',
            helper: 'Gondermeden once nedenini gozden gecir.',
            disclaimer:
              'Anlasmazlik acmak kontrati zincirde donduracak. Hakem her iki tarafin delilini inceledikten sonra fonlarin nasil paylasilacagina karar verecek. Bu islem geri alinamaz.',
            summaryDeal: 'Anlasma',
            summaryReason: 'Neden',
          },
        },
        reason: {
          notDelivered: 'Satici teslim etmedi',
          qualityMismatch: 'Kalite aciklamaya uygun degil',
          unreachable: 'Karsi tarafa ulasilamiyor',
          scopeDisagreement: 'Kapsam anlasmazligi',
          other: 'Diger neden',
          otherPlaceholder: 'Nedenini kisaca yaz...',
        },
        button: {
          continue: 'Devam',
          submit: 'Anlasmazligi gonder',
          submitting: 'Gonderiliyor...',
        },
        error: {
          minLength: 'Lutfen en az 10 karakter yaz.',
          maxLength: 'Neden {{max}} karakteri gecemez.',
          submitFailed: 'Anlasmazlik acilamadi. Lutfen tekrar dene.',
        },
      },
      view: {
        title: 'Anlasmazlik',
        status: {
          open: 'Acik',
          evidence: 'Delil toplaniyor',
          review: 'Inceleniyor',
          resolved: 'Cozuldu',
          appealed: 'Itiraz edildi',
          closed: 'Kapali',
        },
        statusBanner: {
          open: 'Bu anlasmada bir anlasmazlik acildi. Hakem yakinda inceleyecek.',
          evidence:
            'Delil toplama suresi acik. Tarafini desteklemek icin elindeki kanitlari yukle.',
          review: 'Hakem bu anlasmazligi inceliyor.',
          resolved: 'Hakem bu anlasmazligi karara bagladi.',
          appealed: 'Bu anlasmazliga itiraz edildi, ikinci inceleme bekleniyor.',
          closed: 'Bu anlasmazlik kapatildi.',
        },
        originalReason: 'Asil neden',
        backendGap: 'Anlasmazlik detaylari henuz yok',
        backendGapBody:
          'Anlasma donduruldu ama tam anlasmazlik kaydi henuz hazirlaniyor. Birazdan yenile veya hakem atandiktan sonra anlasma sayfasindan tekrar gel.',
        evidence: {
          title: 'Deliller',
          empty: 'Henuz delil sunulmadi.',
          listComingSoon: 'Delil listesi yakinda',
          submittedBy: 'Gonderen: {{actor}}',
          form: {
            title: 'Delil gonder',
            typeLabel: 'Tur',
            type: {
              text: 'Metin',
              link: 'Link',
              image: 'Gorsel URL',
              file: 'Dosya URL',
            },
            contentLabel: 'Icerik',
            contentPlaceholderText:
              'Aciklamani, mesaj dokumunu veya detaylari yaz...',
            contentPlaceholderLink: 'https://ornek.com/kanit',
            contentPlaceholderImage: 'https://ornek.com/ekran-goruntusu.png',
            contentPlaceholderFile: 'https://ornek.com/dosya.pdf',
            submit: 'Delili gonder',
            submitting: 'Gonderiliyor...',
            errorContent: 'Lutfen delilin icerigini yaz.',
            errorSubmit: 'Delil gonderilemedi. Lutfen tekrar dene.',
            success: 'Delil gonderildi',
          },
        },
        defenseBanner: {
          title: 'Karsi taraf anlasmazlik acti',
          body: 'Savunmanizi buradan yazabilirsiniz. 48 saat icinde kanit ve mesaj gonderebilirsiniz.',
          remaining: 'Kalan sure',
        },
        messages: {
          title: 'Mesajlar',
          empty: 'Henuz mesaj yok. Ilk mesaji yazarak savunmaniza baslayin.',
          placeholder: 'Mesajinizi yazin...',
          send: 'Gonder',
          sending: 'Gonderiliyor...',
          errorSend: 'Mesaj gonderilemedi. Tekrar deneyin.',
          readOnly: 'Bu anlasmazlik cozume kavustu — mesajlar artik salt okunur.',
          role: {
            buyer: 'Alici',
            seller: 'Satici',
            arbiter: 'Hakem',
            admin: 'Admin',
          },
          you: 'Sen',
        },
        outcome: {
          title: 'Sonuc',
          buyerWins: 'Alici kazandi — tam iade',
          sellerWins: 'Satici kazandi — fonlar serbest birakildi',
          split: 'Bolusturuldu',
          mutualCancel: 'Karsilikli iptal',
          buyerAmount: 'Alici alir',
          sellerAmount: 'Satici alir',
          resolutionNote: 'Hakem notu',
        },
      },
    },
  },
  invite: {
    title: 'Anlasma daveti',
    subtitle: 'Kabul etmeden once daveti gozden gecir.',
    backToDeals: 'Anlasmalara don',
    hero: {
      from: 'Gonderen',
      amount: 'Tutar',
      for: 'Konu',
    },
    details: {
      description: 'Aciklama',
      terms: 'Ozel sartlar',
      fundingWindow: '{{hours}} saat fonlama suresi',
      expires: '{{relative}} suresi doluyor',
    },
    disclaimer:
      "Kabul ettigin an emanet kontrati blockchain'e yazilir. Alici fonlama suresi icinde kontrati fonlamalidir, aksi halde anlasma otomatik olarak iptal olur.",
    button: {
      accept: 'Daveti kabul et',
      accepting: 'Kabul ediliyor...',
      decline: 'Reddet',
      connectWallet: 'Cuzdan bagla',
    },
    notFound: {
      title: 'Davet artik gecerli degil',
      body: 'Bu davet suresi dolmus, kabul edilmis ya da hic var olmamis. Aliciya yeni bir link gondermesini soyle.',
    },
    error: {
      loadFailed: 'Davet yuklenemedi. Lutfen tekrar dene.',
      acceptFailed: 'Davet kabul edilemedi. Lutfen tekrar dene.',
      selfInvite:
        'Kendi davetini kabul edemezsin. Linki baska bir Telegram kullanicisi ile paylas.',
    },
  },
  admin: {
    queue: {
      title: 'Anlasmazlik Kuyrugu',
      subtitle: 'Hakem incelemesi bekleyen anlasmazliklar',
      empty: {
        title: 'Aktif anlasmazlik yok',
        body: 'Tum anlasmazliklar cozulmus. Yenisi geldiginde burada otomatik gorunecek.',
      },
      filedBy: 'Acan',
      buyer: 'Alici',
      seller: 'Satici',
      amount: 'Tutar',
      reason: 'Sebep',
      filed: 'Acilis',
      review: 'Incele',
      loadError: 'Kuyruk yuklenemedi. Lutfen tekrar dene.',
      unauthorized: 'Bu sayfaya yalnizca hakem ve adminler erisebilir.',
    },
    detail: {
      title: 'Anlasmazligi Coz',
      subtitle: 'Delilleri incele ve karari ver',
      notFound: 'Bu anlasmazlik artik mevcut degil ya da erisim yetkin yok.',
      sectionDeal: 'Anlasma Ozeti',
      sectionParties: 'Taraflar',
      sectionEvidence: 'Deliller',
      sectionDecide: 'Karari Ver',
      noEvidence: 'Hicbir taraf henuz delil sunmadi.',
      contractAddress: 'Kontrat',
      filedBy: 'Acan',
      filedReason: 'Sebep',
      filedAt: 'Acilis zamani',
      evidenceFrom: 'Gonderen',
      evidenceFromBuyer: 'Alici',
      evidenceFromSeller: 'Satici',
      outcome: {
        buyerWins: 'Aliciya Iade (tam)',
        sellerWins: 'Saticiya Birak',
        mutualCancel: 'Karsilikli Iptal (alici iade)',
        split: 'Bol (ozel tutarlar)',
      },
      noteLabel: 'Karar notu (audit log icin gorunur)',
      notePlaceholder: 'Kararini kisa kisa gerekceleyin, ileride audit kaydi anlamli olsun.',
      noteRequired: 'Lutfen karari aciklayan kisa bir not ekle.',
      buyerAmountLabel: 'Alici tutari (TON)',
      sellerAmountLabel: 'Satici tutari (TON)',
      splitWarn:
        'Bol kararinda toplam, anlasma tutarindan kucuk olmali — kontrat dispute fee dusulur.',
      submit: 'Karari Uygula',
      submitting: 'Zincirde cozuluyor...',
      success: 'Anlasmazlik cozuldu',
      error: 'Anlasmazlik cozulemedi. Loglari kontrol edip tekrar dene.',
      confirmTitle: 'Bu anlasmazligi cozmek istiyor musun?',
      confirmBody:
        'Bu islem escrow kontratina op mesaji gonderir ve fonlari yonlendirir. Geri alinamaz.',
      confirmContinue: 'Evet, simdi coz',
      backToQueue: 'Kuyruga don',
    },
    nav: 'Anlasmazlik kuyrugu',
  },
};
